import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`

export const SerachBlock = styled.div`
    position: relative;
    height: 100%;
    z-index: 3;
`
export const SerachBlockSuggestions = styled.div`
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 2;
    background: rgba(0, 0, 0, 0.2); // Make sure this color has an opacity of less than 1
    //backdrop-filter: blur(0.2px); // This be the blur
`

export const TagsBlock = styled.div`
    max-width: 10rem;
    box-sizing: border-box;
    display: flex;
    padding: 0.15rem 1.2rem;
    color: ${ThemeColors.getGrayColor(0.5)};
    font-size: 0.75rem;
    position: absolute;
`

export const TagItem = styled.a`
    padding: 0 0.2rem;
    user-select: none;
    text-decoration: none;
    color: inherit;
    font: inherit;
`
export const TagSpan = styled.span`
    color: inherit;
    font: inherit;
    white-space: nowrap;
    :hover {
        color: ${ThemeColors.getGrayColor(0.5)};
    }
`

export const Input = styled.input`
    width: 100%;
    padding: 0.75rem 1.2rem;
    font-size: 0.9rem;
    height: 100%;
    z-index: 3;
    border: 2px solid ${ThemeColors.accentGreenLight};
    color: ${ThemeColors.getGrayColor(0.7)};
    box-sizing: border-box;
    outline: none;
    -webkit-appearance: none;
    border-radius: 0.3rem;
`

export const SuggestionsBlock = styled.div`
    position: absolute;
    width: 100%;
    font-size: 0.9rem;
    height: 300px;
    border: 2px solid ${ThemeColors.accentGreenLight};
    color: ${ThemeColors.getGrayColor(0.7)};
    box-sizing: border-box;
    outline: none;
    -webkit-appearance: none;
    border-radius: 0.3rem;
    background: white;
    top: 45px;
`

export const IconContainer = styled.div`
    position: absolute;
    width: fit-content;
    height: fit-content;
    top: 0.5rem;
    right: 0.6rem;
    cursor: pointer;
`
